"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryTerms = void 0;
var QueryTerms;
(function (QueryTerms) {
    QueryTerms["exactPhrase"] = "exactPhrase";
    QueryTerms["anyWord"] = "anyWord";
})(QueryTerms = exports.QueryTerms || (exports.QueryTerms = {}));
//# sourceMappingURL=Query.js.map